const europeanCapitals = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        25.261688,
        54.684947,
      ],
    },
    properties: {
      capital: 'Vilnius',
      country: 'Lithuania',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        21.4333,
        42,
      ],
    },
    properties: {
      capital: 'Skopje',
      country: 'North Macedonia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        6.13,
        49.61166,
      ],
    },
    properties: {
      capital: 'Luxembourg',
      country: 'Luxembourg',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        4.890444,
        52.370197,
      ],
    },
    properties: {
      capital: 'Amsterdam',
      country: 'Netherlands',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        1.5225,
        42.5075,
      ],
    },
    properties: {
      capital: 'Andorra la Vella',
      country: 'Andorra',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        -3.71666,
        40.383333,
      ],
    },
    properties: {
      capital: 'Madrid',
      country: 'Spain',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        32.86666,
        39.93333,
      ],
    },
    properties: {
      capital: 'Ankara',
      country: 'Turkey',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        23.33333,
        42.7,
      ],
    },
    properties: {
      capital: 'Sofia',
      country: 'Bulgaria',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        27.566666,
        53.9,
      ],
    },
    properties: {
      capital: 'Minsk',
      country: 'Belarus',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        23.716666,
        37.966666,
      ],
    },
    properties: {
      capital: 'Athens',
      country: 'Greece',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        49.882222,
        40.395278,
      ],
    },
    properties: {
      capital: 'Baku',
      country: 'Azerbaijan',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        7.416666,
        43.73333,
      ],
    },
    properties: {
      capital: 'Monaco',
      country: 'Monaco',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        20.46666,
        44.816666,
      ],
    },
    properties: {
      capital: 'Belgrade',
      country: 'Serbia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        18.068611,
        59.32944,
      ],
    },
    properties: {
      capital: 'Stockholm',
      country: 'Sweden',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        13.383333,
        52.516666,
      ],
    },
    properties: {
      capital: 'Berlin',
      country: 'Germany',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        37.616666,
        55.75,
      ],
    },
    properties: {
      capital: 'Moscow',
      country: 'Russia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        7.45,
        46.95,
      ],
    },
    properties: {
      capital: 'Bern',
      country: 'Switzerland',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        21.01666,
        52.23333,
      ],
    },
    properties: {
      capital: 'Warsaw',
      country: 'Poland',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        17.109722,
        48.143888,
      ],
    },
    properties: {
      capital: 'Bratislava',
      country: 'Slovakia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        33.36666,
        35.16666,
      ],
    },
    properties: {
      capital: 'Nicosia',
      country: 'Cyprus',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        4.35,
        50.85,
      ],
    },
    properties: {
      capital: 'Brussels',
      country: 'Belgium',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        24.745278,
        59.437222,
      ],
    },
    properties: {
      capital: 'Tallinn',
      country: 'Estonia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        26.103888,
        44.4325,
      ],
    },
    properties: {
      capital: 'Bucharest',
      country: 'Romania',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        10.75,
        59.95,
      ],
    },
    properties: {
      capital: 'Oslo',
      country: 'Norway',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        2.3508,
        48.8567,
      ],
    },
    properties: {
      capital: 'Paris',
      country: 'France',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        19.050293,
        47.494009,
      ],
    },
    properties: {
      capital: 'Budapest',
      country: 'Hungary',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        28.847351,
        47.028014,
      ],
    },
    properties: {
      capital: 'Chișinău',
      country: 'Moldova',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        44.78333,
        41.71666,
      ],
    },
    properties: {
      capital: 'Tbilisi',
      country: 'Georgia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        12.568333,
        55.676111,
      ],
    },
    properties: {
      capital: 'Copenhagen',
      country: 'Denmark',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        19.262892,
        42.441286,
      ],
    },
    properties: {
      capital: 'Podgorica',
      country: 'Montenegro',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        -6.259722,
        53.34777,
      ],
    },
    properties: {
      capital: 'Dublin',
      country: 'Ireland',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        44.516666,
        40.18333,
      ],
    },
    properties: {
      capital: 'Yerevan',
      country: 'Armenia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        24.9375,
        60.170833,
      ],
    },
    properties: {
      capital: 'Helsinki',
      country: 'Finland',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        14.41666,
        50.08333,
      ],
    },
    properties: {
      capital: 'Prague',
      country: 'Czech Republic',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        30.523333,
        50.45,
      ],
    },
    properties: {
      capital: 'Kiev',
      country: 'Ukraine',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        19.816,
        41.326,
      ],
    },
    properties: {
      capital: 'Tirana',
      country: 'Albania',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        -9.139444,
        38.713889,
      ],
    },
    properties: {
      capital: 'Lisbon',
      country: 'Portugal',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        14.508333,
        46.05555,
      ],
    },
    properties: {
      capital: 'Ljubljana',
      country: 'Slovenia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        -0.1275,
        51.507222,
      ],
    },
    properties: {
      capital: 'London',
      country: 'United Kingdom',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        9.521,
        47.141,
      ],
    },
    properties: {
      capital: 'Vaduz',
      country: 'Liechtenstein',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        24.106389,
        56.948888,
      ],
    },
    properties: {
      capital: 'Riga',
      country: 'Latvia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        15.98333,
        45.81666,
      ],
    },
    properties: {
      capital: 'Zagreb',
      country: 'Croatia',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        12.5,
        41.9,
      ],
    },
    properties: {
      capital: 'Rome',
      country: 'Italy',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        14.5125,
        35.89777,
      ],
    },
    properties: {
      capital: 'Valletta',
      country: 'Malta',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        12.4473,
        43.9346,
      ],
    },
    properties: {
      capital: 'San Marino',
      country: 'San Marino',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        18.41666,
        43.8666,
      ],
    },
    properties: {
      capital: 'Sarajevo',
      country: 'Bosnia & Herzegovina',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        21.166666,
        42.6666,
      ],
    },
    properties: {
      capital: 'Pristina',
      country: 'Kosovo',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [
        16.36666,
        48.2,
      ],
    },
    properties: {
      capital: 'Vienna',
      country: 'Austria',
    },
  },
  ],
};

export default europeanCapitals;
